const pages = [
    {
        id: 1, // menu location
        forUser: false, // only for admins
        link: '/admin',  // route path
        label: "Roles", // sidebar menu
        title: "Roles", // heading title
        slug: 'roles',
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: true,
        addNewModalTitle: 'Create New Role',
        // fields required for create api with default values
        backendVars: {
            name: 'na',
            permissions: {
                "Alert": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "AlertSlug": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Category": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "CategoryPage": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Cms": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "CmsCategory": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "CmsForm": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "CmsPage": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "CmsSlug": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Component": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "FromEntry": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Form": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "FormFormEntry": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Group": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "GroupTeamMember": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "LocationsPractice": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Mail": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Mail2": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Page": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "PageSlug": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "PracticeData": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "PracticeDataAlert": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "PracticeDataCms": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "PracticeDataGroup": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Practice": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "PracticeLocations": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "PracticePracticeData": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Roles": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Slug": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "TeamMembers": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "User": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "UsersPractice": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "ObjectPermissions": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Training": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Home": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Analytics": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Network": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Settings": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                },
                "Support": {
                  "CREATE": true,
                  "READ": true,
                  "UPDATE": true,
                  "UPDATEMANY": true,
                  "DELETE": true,
                  "LIST": true,
                  "COUNT": true,
                  "EXECUTE": true,
                  "AccessAuthFeature": true
                }
              }
        },
        table: true,
        tableCols: [
            { key: "name", type: "", sortable: false },
            { key: "CREATE", type: "checkbox", sortable: false },
            { key: "READ", type: "checkbox", sortable: false },
            { key: "UPDATE", type: "checkbox", sortable: false },
            { key: "UPDATEMANY", type: "checkbox", sortable: false },
            { key: "DELETE", type: "checkbox", sortable: false },
            { key: "LIST", type: "checkbox", sortable: false },
            { key: "COUNT", type: "checkbox", sortable: false },
            { key: "EXECUTE", type: "checkbox", sortable: false },
            { key: "AccessAuthFeature", type: "checkbox", sortable: false },
        ],
        formData: {},
        schema: {
          name: {
              type: 'text',
              label: 'Name',
              placeholder: 'Enter Name',
              required: true,
              info: false,
              character_count: 50
          },
        },
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
        api: '/api/roles/',
        // define active mode, 'single' OR 'multiple'
        // activeRule not required for 'multiple'
        // in 'single' mode activeRule can be either any common field or 'null' for all
        activeConfig: {
            activeMode: 'multiple',
            activeRule: null,           
        },
        pageFormData: {},
        pageSchema: {
            name: {
                type: 'text',
                label: 'Mail Title',
                placeholder: 'Enter Mail Title',
                required: true,
                info: true,
                character_count: 250
            },
            // type: {
            //     type: 'select',
            //     label: 'Type',
            //     options: ['Red', 'Yellow', 'Green'],        
            //     required: false,
            //     info: false,
            //     character_count: 0,
            //     wrapper_class: 'col-6'
            // },
        },
    },
    {
        id: 1, // menu location
        forUser: false, // only for admins
        link: '/admin',  // route path
        label: "Mail", // sidebar menu
        title: "Mail", // heading title
        slug: 'mail',
        lastUpdated: '31 Dec 2020 15:00',
        addNewBtn: true,
        addNewModalTitle: 'Create New Mail',
        // fields required for create api with default values
        backendVars: {
            name: 'na',
            subject: 'Verification Code',
            from: 'cms@patientlink.digital',
            body: 'na',
            host: 'localhost',
            port: '442',
            username: 'test',
            password: 'test123',
            type: 'Forgot Password',
            active: false,
            additionalProp1: {}
        },
        formData: {},
        schema: {
          name: {
              type: 'text',
              label: 'Name',
              placeholder: 'Enter Name',
              required: true,
              info: false,
              character_count: 50
          },
        },
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
        api: '/api/mail/',
        // define active mode, 'single' OR 'multiple'
        // activeRule not required for 'multiple'
        // in 'single' mode activeRule can be either any common field or 'null' for all
        activeConfig: {
            activeMode: 'single',
            activeRule: 'type',           
        },
        pageFormData: {},
        pageSchema: {
            name: {
                type: 'text',
                label: 'Mail Title',
                placeholder: 'Enter Mail Title',
                required: true,
                info: true,
                character_count: 250
            },
            subject: {
                type: 'text',
                label: 'Mail Subject',
                placeholder: 'Enter Mail Subject',
                required: true,
                info: false,
                character_count: 0,
                wrapper_class: 'col-6',
                tooltip: '####CODE#### is equals to verfication code. ####NAME#### is equals to username. ',
            },
            from: {
                type: 'email',
                label: 'Sender Mail',
                placeholder: 'Enter Sender Mail',
                required: true,
                info: false,
                character_count: 0,
                wrapper_class: 'col-6'
            },
            body: {
                type: 'ckeditor',
                label: 'Mail Body',
                required: true,
                info: false,
                character_count: 2000,
                tooltip: '####CODE#### is equals to verfication code. ####NAME#### is equals to username. ',
            },
            host: {
              type: 'text',
              label: 'Conection Host',
              required: true,
              info: false,
              character_count: 0,
              wrapper_class: 'col-8'
            },
            port: {
              type: 'number',
              label: 'Port',
              required: true,
              info: false,
              character_count: 0,
              wrapper_class: 'col-4'
            },
            username: {
              type: 'text',
              label: 'Username',
              required: true,
              info: false,
              character_count: 0
            },
            password: {
              type: 'text',
              label: 'Password',
              required: true,
              info: false,
              character_count: 0
            },
            type: {
                type: 'select',
                label: 'Type',
                options: ['Forgot Password', 'Login Code', 'First Time Password'],        
                required: false,
                info: false,
                character_count: 0,
                wrapper_class: 'col-6'
            },
        },
    },
    // {
    //     id: 2, // menu location
    //     forUser: false, // only for admins
    //     link: '/admin',  // route path
    //     label: "Mail 2", // sidebar menu
    //     title: "Mail 2", // heading title
    //     slug: 'mail2',
    //     lastUpdated: '31 Dec 2020 15:00',
    //     addNewBtn: true,
    //     addNewModalTitle: 'Create New Mail 2',
    //     // fields required for create api with default values
    //     backendVars: {
    //         name: 'na',
    //         type: 'Red',
    //         active: false,
    //     //     table: [
    //     //         {
    //     //             name: 'John',
    //     //             age: 25
    //     //         },
    //     //         {
    //     //             name: 'Doe',
    //     //             age: 22
    //     //         },
    //     //         {
    //     //             name: 'Harris',
    //     //             age: 19
    //     //         },
    //     // ],
    //         table: {
    //             'john': {
    //                 age: '19',
    //                 race: 'black'
    //             },                     
    //             'harris': {
    //                 age: '27',
    //                 race: 'asian'
    //             },              
    //         }
    //     },

    //     table: true,
    //     tableCols: [
    //         { key: "name", type: "", sortable: false },
    //         { key: "age", type: "number", sortable: false },
    //         { key: "yellow", type: "checkbox", sortable: false },
    //         { key: "red", type: "radio", sortable: false },
    //         { key: "race", type: "time", sortable: false },
    //         { key: "blue", type: "date", sortable: false },
    //         { key: "purple", type: "select", options: ['Yes', 'No'], sortable: false },
    //     ],
    //     formData: {},
    //     schema: {
    //       name: {
    //           type: 'text',
    //           label: 'Name',
    //           placeholder: 'Enter Name',
    //           required: true,
    //           info: false,
    //           character_count: 50
    //       },
    //     },
    //     deleteBtn: false,
    //     activeBtn: false,
    //     submitBtn: false,
    //     api: '/api/mail2s/',
    //     // define active mode, 'single' OR 'multiple'
    //     // activeRule not required for 'multiple'
    //     // in 'single' mode activeRule can be either any common field or 'null' for all
    //     activeConfig: {
    //         activeMode: 'single',
    //         activeRule: null,           
    //     },
    //     pageFormData: {},
    //     pageSchema: {
    //         name: {
    //             type: 'text',
    //             label: 'Mail Title',
    //             placeholder: 'Enter Mail Title',
    //             required: true,
    //             info: true,
    //             character_count: 250
    //         },
    //         type: {
    //             type: 'select',
    //             label: 'Type',
    //             options: ['Red', 'Yellow', 'Green'],        
    //             required: false,
    //             info: false,
    //             character_count: 0,
    //             wrapper_class: 'col-6'
    //         },
    //     },
    // },
]

export { pages };